module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"title":"Estamos analisando as informações","description":"Agora é só aguardar. Em algumas horas o resultado da análise vai estar disponível."},"en-US":{"title":"We are analysing the information","description":"For now just wait. In a few hours the analysis result will be available here."}}')
  delete Component.options._Ctor
}
